import { ChangeEvent, SetStateAction } from "react";
import { Option } from "../../../types/General/Option";
import { Box, Flex, Heading } from "@chakra-ui/react";
import SelectComponent from "../../../components/molecule/Select/SelectComponent";
import DatePickerComponent from "../../../components/molecule/DatePicker/DatePickerComponent";
import { Dayjs } from "dayjs";
import { graphFilterStyle } from "../../../utils/styles/Graph/graphFilter";

export const historyGraphSelectFilterData = (
  startPeriodOptions: Option[],
  endPeriodOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setStartYear: (date: Dayjs | null) => void,
  setEndYear: (date: Dayjs | null) => void,
  setSelectedStartPeriod: SetStateAction<any>,
  setSelectedEndPeriod: SetStateAction<any>,
  selectedStartYear: Dayjs | null,
  selectedEndYear: Dayjs | null,
  periodLoaded: boolean,
) => {
  const handleStartPeriodChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedStartPeriodId = e.target.value;
    const selected = startPeriodOptions.find(
      (p) => p.id.toString() === selectedStartPeriodId,
    );
    setSelectedStartPeriod(selected || null);
    setFilter("StartPeriod", selectedStartPeriodId);
  };

  const handleEndPeriodChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedEndPeriodId = e.target.value;
    const selected = endPeriodOptions.find(
      (p) => p.id.toString() === selectedEndPeriodId,
    );
    setSelectedEndPeriod(selected || null);
    setFilter("EndPeriod", selectedEndPeriodId);
  };

  const handleStartYearChange = (date: Dayjs | null) => {
    setStartYear(date || null);
    setFilter("StartYear", date ? date.format("YYYY") : undefined);
  };

  const handleEndYearChange = (date: Dayjs | null) => {
    setEndYear(date || null);
    setFilter("EndYear", date ? date.format("YYYY") : undefined);
  };

  return (
    <Flex sx={graphFilterStyle}>
      <Flex direction="column" gap="2" width="50%">
        <Heading fontSize="xs" fontStyle="bold" textTransform="uppercase">
          Início
        </Heading>
        <Flex gap="4">
          <SelectComponent
            fieldNameObject="StartPeriod"
            options={startPeriodOptions}
            fieldName="Período"
            control={control}
            onChange={handleStartPeriodChange}
            isLoaded={periodLoaded}
          />
          <DatePickerComponent
            label="Ano"
            fieldName="StartYear"
            selectedDate={selectedStartYear}
            onChange={handleStartYearChange}
            mode="year"
            format="YYYY"
            control={control}
          />
        </Flex>
      </Flex>
      <Box
        as="hr"
        borderColor="gray.400"
        height="100px"
        borderWidth="0"
        borderLeftWidth="2px"
        marginX="0"
        marginY="0"
      />
      <Flex direction="column" gap="2" width="50%">
        <Heading fontSize="xs" fontStyle="bold" textTransform="uppercase">
          Fim
        </Heading>
        <Flex gap="4">
          <SelectComponent
            fieldNameObject="EndPeriod"
            options={endPeriodOptions}
            fieldName="Período"
            control={control}
            onChange={handleEndPeriodChange}
            isLoaded={periodLoaded}
          />
          <DatePickerComponent
            label="Ano"
            fieldName="EndYear"
            selectedDate={selectedEndYear}
            onChange={handleEndYearChange}
            mode="year"
            format="YYYY"
            control={control}
            minDate={selectedStartYear || undefined}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
